/* Empujon unico en los carruseles de comparacion.

   No es rotacion automatica: el contenido nunca se mueve mientras el usuario lee.
   La primera vez que el carrusel entra en pantalla se desplaza y regresa una sola
   vez, para que se entienda que se puede deslizar. Despues no se mueve nunca mas.
   Si el visitante pidio reducir animaciones, no hace nada.

   Nota: el umbral debe ser bajo. Las tarjetas son altas y en un celular la seccion
   nunca llega a estar mitad visible, asi que un umbral alto no se dispara jamas. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var DIST = 54;

  function scrollable(el) {
    return el.scrollWidth - el.clientWidth > 30;
  }

  function move(el, left) {
    try {
      el.scrollTo({ left: left, behavior: 'smooth' });
    } catch (e) {
      el.scrollLeft = left;
    }
  }

  function nudge(el) {
    if (el.dataset.mbNudged === '1') return;
    if (!scrollable(el) || el.scrollLeft > 6) return;
    el.dataset.mbNudged = '1';

    move(el, DIST);
    setTimeout(function () { move(el, 0); }, 520);
  }

  function init() {
    var grids = document.querySelectorAll('.mb-cmp-grid');
    if (!grids.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          setTimeout(function () { nudge(el); }, 350);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    grids.forEach(function (g) {
      if (g.dataset.mbObserved === '1') return;
      g.dataset.mbObserved = '1';
      io.observe(g);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
